/**
 * ProcessThread API Client
 * Handles all API calls for ProcessThread entities
 */

import { BaseApiClient, ApiResponse, RequestOptions } from './baseApiClient';
import { API_ENDPOINTS } from '../config/apiEndpoints';
import {
  ProcessThread,
  CreateProcessThreadRequest,
  UpdateProcessThreadRequest,
  StandardListRequest,
  GetByIdRequest,
  DeleteRequest,
  SearchRequest,
} from '../types';

export class ProcessThreadApiClient extends BaseApiClient {
  async getAll(request: StandardListRequest = {}): Promise<ApiResponse<ProcessThread[]>> {
    return this.postQuery<ProcessThread[]>(API_ENDPOINTS.PROCESS_THREADS.LIST, request);
  }

  async getById(request: GetByIdRequest): Promise<ApiResponse<ProcessThread>> {
    return this.postQuery<ProcessThread>(API_ENDPOINTS.PROCESS_THREADS.GET_BY_ID, { ID: { ID: request.id, ResID: '' } });
  }

  async create(request: CreateProcessThreadRequest): Promise<ApiResponse<ProcessThread>> {
    return this.post<ProcessThread>(API_ENDPOINTS.PROCESS_THREADS.CREATE, request);
  }

  async update(request: UpdateProcessThreadRequest): Promise<ApiResponse<ProcessThread>> {
    // C# API expects the full entity including ProcessThreadID in the body
    // The controller validates that the ID in the body matches the ID in the route
    return this.put<ProcessThread>(API_ENDPOINTS.PROCESS_THREADS.UPDATE(request.ProcessThreadID), request);
  }

  async deleteProcessThread(request: DeleteRequest): Promise<ApiResponse<void>> {
    // C# API expects DeleteWebRequest with ID property
    const deleteRequestBody = {
      ID: {
        ID: request.id,
        ResID: '',
      },
    };
    return super.delete<void>(API_ENDPOINTS.PROCESS_THREADS.DELETE(request.id), deleteRequestBody);
  }

  async getByProcess(processId: number, request: SearchRequest = {}, options?: RequestOptions): Promise<ApiResponse<ProcessThread[]>> {
    return this.postQuery<ProcessThread[]>(API_ENDPOINTS.PROCESS_THREADS.BY_PROCESS, { ...request, ProcessID: processId }, options);
  }

  async getActive(request: SearchRequest = {}): Promise<ApiResponse<ProcessThread[]>> {
    return this.postQuery<ProcessThread[]>(API_ENDPOINTS.PROCESS_THREADS.ACTIVE, request);
  }

  async getTemplates(request: SearchRequest = {}): Promise<ApiResponse<ProcessThread[]>> {
    return this.postQuery<ProcessThread[]>(API_ENDPOINTS.PROCESS_THREADS.TEMPLATES, request);
  }
}

export const processThreadApiClient = new ProcessThreadApiClient();
